<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'

import { usePageStore } from '../../stores/page'
import Teaser from '../teaser/Teaser.vue'
import AdaAdSlot from '../ad-slots/AdaAdSlot.vue'
import { useClient } from '../../utils/client-only'

import type { TeaserObject } from '../../composables/use-teaser'

const props = withDefaults(defineProps<{
  position?: 'top' | 'bottom'
}>(), {
  position: 'top'
})

const { isClient } = useClient()
const { pageData, brandFromStore } = storeToRefs(usePageStore())

const slotIdOffset = { top: 10, bottom: 13 }
const teaserCount = { top: 3, bottom: 6 }

const fallbackTeaserData = computed<TeaserObject[]>(() => {
  if (props.position === 'top' && pageData.value?.metaData?.nativeCrossbarTop) {
    return [...pageData.value.metaData.nativeCrossbarTop]
  }
  if (props.position === 'bottom' && pageData.value?.metaData?.nativeCrossbarBottom) {
    return [...pageData.value.metaData.nativeCrossbarBottom]
  }
  return []
})
</script>

<template>
  <div :data-ncb-position="position"
       class="bx-ada bx-ada--native-crossbar bx-teaser-container bx-teaser-container--one-third-width">
    <AdaAdSlot v-for="i in teaserCount[position]"
               :key="`teaser-${slotIdOffset[position] + i}`"
               :slot-id="slotIdOffset[position] + i"
               slot-name="teaser">
      <template #ncbFallbackTeaser>
        <Teaser v-if="isClient && fallbackTeaserData?.length"
                :id="`teaser_${slotIdOffset[position] + i}_fallback`"
                :composed-teaser="fallbackTeaserData.splice((Math.floor(Math.random() * fallbackTeaserData.length)), 1)[0]"
                :list-order-position="10"
                :meta-data="{
                  brand: brandFromStore,
                  teaserGroupType: 'bx-teaser-container--one-third-width'
                }" />
      </template>
    </AdaAdSlot>
  </div>
</template>
